// extracted by mini-css-extract-plugin
module.exports = {"container":"ContextMenu_container__6dmyI","sectionDivider":"ContextMenu_sectionDivider__2vlqU"};